import { BaseModel } from '@/api/base-model'
import { AttachmentAPI } from '@/api/backend-client'
import { Referral } from '@/api/model/referral'

export class Attachment extends BaseModel<Attachment> {
    protected collectionName = AttachmentAPI.collectionName

    constructor(
        public referral: Referral|null,
        public id: string,
        public name: string,
        public description: string,
        public source: string,
        public uploadedByContact: boolean,
        public url: string,
        public createdAt: Date,
        public updatedAt: Date,
    ) { super(id) }

    static fromData(data: any): Attachment {
        if (data === null || typeof data === 'string' || data instanceof Attachment) {
            return data
        }

        return new Attachment(
            data.referral ? Referral.fromData(data.referral) : null,
            data.id,
            data.name,
            data.description,
            data.source,
            data.uploadedByContact ?? false,
            data.url,
            data.createdAt,
            data.updatedAt,
        )
    }
}
